module.exports = __webpack_public_path__ + "static/img/donwloadAppMobile.d5b6ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donwloadAppMobile.png
// module id = baoC
// module chunks = 12